import { useRef, useState } from "react";
import { useRecipePhotoUrl } from "./photoUrl.js";
import { sync } from "../../sync/SyncService.js";
import type { PhotoSize } from "@recipevault/shared";

type Props = {
  householdId: string;
  recipeId: string;
  photoKey: string | null;
  size: PhotoSize;
  alt: string;
  className?: string;
};

export function RecipePhotoImg({ householdId, recipeId, photoKey, size, alt, className }: Props) {
  const url = useRecipePhotoUrl({ householdId, recipeId, photoKey, size });
  const [cacheBust, setCacheBust] = useState<number | null>(null);
  const refreshAttempted = useRef(false);

  if (!url) return null;

  async function handleError(): Promise<void> {
    if (refreshAttempted.current) return; // one retry per mount
    refreshAttempted.current = true;
    try {
      await sync.refreshCdnCookies();
      setCacheBust(Date.now());
    } catch {
      // Refresh failed — leave the broken img in place; SyncService will retry
      // on its own schedule.
    }
  }

  const finalSrc = cacheBust != null ? `${url}?retry=${cacheBust}` : url;

  return (
    <img
      src={finalSrc}
      alt={alt}
      className={className}
      onError={() => {
        void handleError();
      }}
      loading="lazy"
      decoding="async"
    />
  );
}
